export const CACHE_LIFESPAN_IN_MILLISECONDS = 900 * 1000

export const getGraphQlApiEndpoint = () => {
  const apiEndpointURL = {
    test: 'https://tst-itf-kube.clubspark.io/graphql',
    stage: 'https://stg-itf-kube.clubspark.io/graphql',
  }
  const endpoint = window?.environmentSettingsConfig?.GatewayEndpoint

  return endpoint ? `${endpoint}graphql` : apiEndpointURL.test //select env for local dev
}

export const getWebRootUrl = () => {
  return window.location.origin
}

export const getClassicUrl = () => {
  const endpoint = window?.environmentSettingsConfig?.WebRootUrl

  return endpoint ? endpoint : 'https://stg-itf-web.clubspark.io/'
}

export const getRcUrl = () => {
  const endpoint = window?.environmentSettingsConfig?.RcUrl

  return endpoint ? endpoint : ''
}

export const getClassicApiEndpoint = () => {
  const endpoint = window?.environmentSettingsConfig?.ApiRootUrl

  return endpoint ? endpoint : 'https://stg-itf-api.clubspark.io/'
}

export const getAuthRootUrl = () => {
  const endpoint = window?.environmentSettingsConfig?.AuthRootUrl

  return endpoint ? endpoint : 'https://stg-itf-auth.clubspark.io/'
}

export const getRecaptchaApiKey = () => {
  const publicKey = window?.environmentSettingsConfig?.RecaptchaPublicKey

  return publicKey ? publicKey : 'insert recaptcha public key'
}
